<template>
    <!-- 绩效管理 -->
    <productSchema :config="config"></productSchema>
</template>

<script>
import { config } from './js/Overall'
import productSchema from '../common/product_schema.vue'
export default {
    name: '',
    components: { productSchema },
    data() {
        return {
            config: config,
        };
    },
    computed: {
    },
    watch: {
    },
    mounted(){
    },
    methods: {

    },
};
</script>

<style scoped lang="less">
.odr {}
</style>
